import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'src/constants';
import ApiService from 'src/modules/api-service';
import { useAuthenticationStore } from 'src/stores/Authentication';

export const useUser = () => {
  const {
    state: { hasAccess },
  } = useAuthenticationStore();

  return useQuery([QueryKeys.currentUser], () => ApiService.auth.authControllerMe().then((res) => res.data), {
    suspense: true,
    staleTime: Infinity,
    enabled: hasAccess,
  });
};
